<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card class=''>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center>
                      <v-container fluid>
                        <v-form v-model="valid" ref="form" lazy-validation >
                          <v-flex xs12>
                            <v-text-field
                            label="*Nome"
                            v-model="empresaData.name"
                            :rules="[v => !!v || 'Nome é obrigatório']"
                            :counter="100"
                            maxlength="100"
                            required
                            ></v-text-field>
                            <v-text-field
                            label="*Razão Social"
                            v-model="empresaData.razao_social"
                            :rules="[v => !!v || 'Razão social é obrigatório']"
                            :counter="100"
                            maxlength="100"
                            required
                            ></v-text-field>
                            <v-select
                            :rules="[v => !!v || 'Tipo é obrigatório']"
                            label="*Tipo de contrato"
                            item-text="tipo"
                            item-value="acron"
                            :items="tipolugar"
                            max-height="400"
                            v-model="empresaData.tipo"
                            ></v-select>
                            <v-text-field
                              label="*CNPJ"
                              v-model="empresaData.cnpj"
                              :rules="CNPJRules"
                              required
                              mask="##.###.###/####-##"
                            ></v-text-field>
                            <v-text-field
                              label="CEP"
                              @change="getCEP(empresaData.cep)"
                              v-model="empresaData.cep"
                              mask="#####-###"
                            ></v-text-field>
                            <v-text-field
                              label="Logradouro"
                              v-model="empresaData.logradouro"
                              ref="rua"
                              :counter="100"
                              maxlength="100"
                            ></v-text-field>
                            <v-text-field
                              label="Número"
                              :counter="10"
                              maxlength="10"
                              v-model="empresaData.numero"
                            ></v-text-field> 
                            <v-text-field
                              label="Complemento"
                              v-model="empresaData.complemento"
                              ref="complemento"
                            ></v-text-field>
                            <v-text-field
                              label="Bairro"
                              v-model="empresaData.bairro"
                              ref="bairro"
                            ></v-text-field> 
                            <v-text-field
                              label="Cidade"
                              v-model="empresaData.cidade"
                              ref="cidade"
                              :counter="50"
                              maxlength="50"
                            ></v-text-field>
                            <v-text-field
                              label="Estado"
                              v-model="empresaData.estado"
                              ref="estado"
                              mask="AA"
                            ></v-text-field>
                            <v-text-field
                              label="Número de Licenças"
                              v-model="empresaData.licencas"
                              type="number"
                            ></v-text-field>
                            <!-- <v-autocomplete 
                              v-if="empresaData.tipo === 'P'"
                              label="Responsável"
                              :items="usuario"
                              item-text="username"
                              item-value="id"
                              autocomplete
                              v-model="empresaData.responsavel"
                              max-height="400"
                              hint="Escolha o usuário"
                              persistent-hint
                            ></v-autocomplete> -->
                          </v-flex>
                        </v-form>
                      </v-container>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"  @click.native="proximo" >Continuar</v-btn>
                  </v-card-actions>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
// import api from '@/api'
export default {
  components: {
  },
  data () {
    return {
      empresaData: {},
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      tipolugar: [
            {acron: 'P', tipo: 'Proprietário'},
            {acron: 'M', tipo: 'MakerLab'}
      ],
      editing: false,
      options: [],
      animation: false,
      unidade: [],
      programas: [],
      usuario: [],
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => this.validemail(v)
      ],
      CNPJRules: [
        v => !!v || 'CNPJ é obrigatório'
        // v => this.validarCNPJ(v)
      ],
      path: '',
      valid: true,
      loading: false
    }
  },
  created () {
    // api.request('GET', 'search-user?groups__name=Admin').then((response) => {
    //   this.usuario = response.data
    // })
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    validemail (value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'E-mail inválido'
    },
    validarCNPJ (c) {
      var n
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

      if ((c = c.replace(/[^\d]/g, '')).length !== 14) { return false; }

      if (/0{14}/.test(c)) { return false; }

      for (let i = 0, n = 0; i < 12; n += c[i] * b[++i]);
      if (c[12] !== (((n %= 11) < 2) ? 0 : 11 - n)) { return false; }

      for (let i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
      if (c[13] !== (((n %= 11) < 2) ? 0 : 11 - n)) { return false; }

      return true;
    },
    proximo () {
      if (this.$refs.form.validate()) {
        this.$emit('dados1', this.empresaData)
        this.$emit('next')
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    getCEP (valor) {
      var cep = valor.replace(/\D/g, '')

      var xhr = new XMLHttpRequest();
      var url = 'https://viacep.com.br/ws/' + cep + '/json'
      xhr.open('GET', url, true);
      xhr.responseType = 'json';
      xhr.onload = () => {
        var status = xhr.status;
        if (status === 200) {
          this.$refs.rua.value = xhr.response.logradouro
          this.empresaData.logradouro = xhr.response.logradouro
          this.$refs.cidade.value = xhr.response.localidade
          this.empresaData.cidade = xhr.response.localidade
          this.$refs.bairro.value = xhr.response.bairro
          this.empresaData.bairro = xhr.response.bairro
          this.$refs.estado.value = xhr.response.uf
          this.empresaData.estado = xhr.response.uf
          this.$refs.complemento.value = xhr.response.complemento
          this.empresaData.complemento = xhr.response.complemento
        } else {
          console.log(status)
        }
      };
      xhr.send()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Empresas/CadastroSteps/Step1.vue